import { store } from '@store/online/index';
import { ActiveRestaurant } from '../app/(routes)/online-ordering/types';
import { getMenuOnlyFlag } from '../utils/UtilFunctions';
import { updateDealSettings } from '@store/online/deal/dealSlice';
import { updateGiftCardSettings } from '@store/online/giftCards/giftCardSlice';
export const onlineRoute = '/online-ordering';
export const homeRoute = '/';
export const myOrdersRoute = '/my-orders';
export const onlineOrderingRoute = '/online-ordering/';

const getOrderingQueryParams = (isQr: boolean) => {
  const isMenuOnlyFlag = getMenuOnlyFlag();

  return [isQr && 'qr=true', isMenuOnlyFlag && 'menu'].filter(Boolean).join('&');
};

export const dynamicBusinessRoute = () => {
  const tenantName = store.getState()?.restaurant?.tenantName;
  const isDeals = store.getState()?.deal?.isDeals;
  const isGiftCard = store.getState()?.giftCard?.isGiftCard;
  const orderingUrl = `/online-ordering/${tenantName}`;
  //store states
  const isQr = store.getState().restaurant.isQr;

  if (isDeals) {
    store.dispatch(updateDealSettings({ isDeals: false }));
    return `${orderingUrl}/deals`;
  }

  if (isGiftCard) {
    const giftCardUrl = getGiftCardViewUrl();
    store.dispatch(updateGiftCardSettings({ isGiftCard: false, toRedirect: null }));
    if (giftCardUrl && giftCardUrl.length > 0) {
      return giftCardUrl;
    }
  }

  const queryParams = getOrderingQueryParams(isQr);
  return tenantName ? `${orderingUrl}${queryParams ? `?${queryParams}` : ''}` : onlineRoute;
};
export const dynamicRewardsRoute = () => {
  const tenantName = store.getState().restaurant.tenantName;
  return tenantName ? `/online-ordering/${tenantName}/rewards` : onlineRoute;
};
export const dynamicAuthBusinessRoute = () => {
  const tenantName = store.getState().restaurant.tenantName;
  return tenantName ? `/online-ordering/${tenantName}` : onlineRoute;
};
export const dynamicBusinessRouteByCookies = (tenantName: string | undefined, isQr?: boolean, isMenuOnly?: boolean) => {
  const isMenuOnlyFlag = getMenuOnlyFlag();
  const queryParams = [isQr && 'qr=true', (isMenuOnlyFlag || isMenuOnly) && 'menu'].filter(Boolean).join('&');
  const orderingUrl = `/online-ordering/${tenantName}`;

  return tenantName ? `${orderingUrl}${queryParams ? `?${queryParams}` : ''}` : onlineRoute;
};
export const dynamicQrRoute = () => {
  const tenantName = store.getState().restaurant.tenantName;
  const tableNo = store.getState().restaurant.tableNo;
  return tableNo ? `/${tenantName}?table=${tableNo}` : `/${tenantName}`;
};
export const checkoutUrls = {
  onlineOrdering: '/online-ordering/checkout',
  qrOrdering: `/online-ordering/checkout/qr-success?qr=true`,
  postOrdering: `/post-ordering`,
};
export const privacyPolicy = 'https://www.aioapp.com/privacy-policy';
export const termofUse = 'https://www.aioapp.com/terms-of-use';
export const dynamicRewardRoute = () => {
  const tenantName = store.getState().restaurant.tenantName;
  return tenantName ? `/online-ordering/${tenantName}/rewards` : onlineRoute;
};

export const cartRoute = () => {
  const tenantName = store.getState().restaurant.tenantName;
  return tenantName ? `/online-ordering/${tenantName}/cart` : onlineRoute;
};

export const cartRouteQr = () => {
  const tenantName = store.getState().restaurant.tenantName;
  return tenantName ? `/online-ordering/${tenantName}/cart?qr=true` : onlineRoute;
};
export const getDealsUrl = () => {
  const tenantName = store.getState().restaurant.tenantName;
  const orderingUrl = `/online-ordering/${tenantName}`;

  return `${orderingUrl}/deals`;
};

export const getGiftCardViewUrl = () => {
  const toRedirect = store.getState()?.giftCard?.toRedirect;

  if (toRedirect) {
    return toRedirect;
  }

  const activeRestaurant = store.getState()?.restaurant?.activeRestaurant;
  if (activeRestaurant?.businessAlias && activeRestaurant?.restaurantAlias) {
    return `/${activeRestaurant.businessAlias}/${activeRestaurant.restaurantAlias}/gift-card?view_only=true`;
  }
  return '';
};

export const getGiftCardAddUrl = (activeRestaurant: ActiveRestaurant) => {
  if (activeRestaurant?.businessAlias && activeRestaurant?.restaurantAlias) {
    return `/${activeRestaurant.businessAlias}/${activeRestaurant.restaurantAlias}/gift-cards/add`;
  }
  return '';
};

export const getExploreGiftCardsUrl = () => {
  const activeRestaurant = store.getState()?.restaurant?.activeRestaurant;
  if (activeRestaurant?.businessAlias && activeRestaurant?.restaurantAlias) {
    return `/${activeRestaurant.businessAlias}/${activeRestaurant.restaurantAlias}/gift-card`;
  }
  return '';
};
